import React, { cloneElement, ReactElement, useRef } from 'react'
import Slider from 'react-slick'

import useWindowDimensions from 'aem-libs-react-ts/src/hooks/useWindowDimensions'

const SPEED = 500

const sliderSettings = {
  adaptiveHeight: true,
  dots: false,
  infinite: false,
  speed: SPEED,
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: false,
  draggable: false,
  touchMove: false,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
}

interface IProps {
  inputComponent: ReactElement
  resultComponent: ReactElement
  containerClass?: string
}

export interface ICalcComponent {
  onChangeView?: () => void
}

const CalcView = (props: IProps) => {

  const { width } = useWindowDimensions()
  const { containerClass, inputComponent, resultComponent } = props

  const sliderRef: any = useRef()
  const containerRef: any = useRef()

  const handleChangeScreen = () => {
    setTimeout(() => {
      containerRef.current.scrollIntoView()
      window.scrollBy(0, -87)
    }, SPEED)
  }

  const handleNextSlide = () => {
    sliderRef.current.slickNext()
  }

  const handlePrevSlide = () => {
    sliderRef.current.slickPrev()
  }

  const enhancedInput = () => cloneElement(inputComponent, {
    onChangeView: () => handleNextSlide(),
    props: { ...inputComponent.props },
  })

  const enhancedResult = () => cloneElement(resultComponent, {
    onChangeView: () => handlePrevSlide(),
    props: { ...resultComponent.props },
  })

  const getInput = () => (
    <React.Fragment key={0} >
      {enhancedInput()}
    </React.Fragment>
  )

  const getResult = () => (
    <React.Fragment key={1} >
      {enhancedResult()}
    </React.Fragment>
  )

  const getSlider = () => (
    <Slider {...sliderSettings} ref={sliderRef} beforeChange={handleChangeScreen}>
      <>{getInput()}</>
      <>{getResult()}</>
    </Slider>
  )

  return (
    <div className={containerClass} ref={containerRef}>
      {width > 767 && [getInput(), getResult()]}
      {width <= 767 && getSlider()}
    </div>
  )
}

export default CalcView
